import React from "react";
import "../styles/Projects.css";

class Projects extends React.Component {
  render() {
    const projects = [
      {
        techStack: [
          "Swift",
          "SwiftUI",
          "MLX",
          "Apple Silicon",
          "Distributed Computing",
          "macOS",
        ],
        title: "Setup Assistant for MLX Mac Cluster",
        desc: "A native macOS application for discovering, visualizing, and orchestrating distributed MLX machine-learning workloads across clusters of Apple Silicon Macs, making multi-device distributed computing accessible for demos, education, and experimentation. Built as an MSU capstone project sponsored by Apple.",
        url: "https://github.com/MSU-CSE498-SS26-Apple/Setup-Assistant-for-MLX-Mac-Cluster",
      },
      {
        techStack: ["ROS-2", "SLAM", "Autonomous Vehicles", "AI", "Robotics"],
        title: "Linguistic Instruction Follower (LIF)",
        desc: "A ROS-2 autonomous navigation system that leverages an LLM to translate natural-language room intent into indoor waypoints, enabling reliable navigation in a SLAM-mapped environment with automated arrival notification.",
        url: "https://gitlab.msu.edu/demarc39/av_project_10/-/tree/629b35dc4a3aec04d47949247e37d3999eb5b5e0/",
      },
      {
        techStack: ["Flutter", "Docker", "Bounded Model Checking"],
        title: "HyperQB 2.0",
        desc: "A push-button, bounded model checker for verifying hyperproperties (Hsu et al.)",
        url: "https://hyperqb.github.io/",
      },
      {
        techStack: ["React.js", "DSA", "Tailwind CSS"],
        title: "A* (Star) Visualizer",
        desc: "Interactive tool that visually demonstrates how the A* pathfinding algorithm navigates grids to find the shortest path.",
        url: "/astar-visualizer",
      },
      {
        techStack: ["Python", "REST APIs"],
        title: "Latest Bops",
        desc: "A script designed to optimize phone storage by maintaining a smaller Spotify playlist that includes the latest tracks from your main playlist, organized from newest to oldest.",
        url: "https://github.com/marcoaobatista/Latest-Bops",
      },
      {
        techStack: ["React.js", "REST APIs", "Tailwind CSS"],
        title: "Bible Verses",
        desc: "Saved Bible verses for personal memorization, seamlessly integrated with the Bible app using Apple Shortcuts.",
        url: "/bible-verses",
      },
      {
        techStack: ["Javascript", "HTML", "CSS"],
        title: "Done Todo List",
        desc: "A fully functional todo list web application with IndexedDB.",
        url: "https://github.com/marcoaobatista/Done-To-do-List-App",
      },
      {
        techStack: ["Python"],
        title: "Python Calculator",
        desc: "A calculator program written in Python.",
        url: "https://github.com/marcoaobatista/Python-Calculator",
      },
      {
        techStack: ["Python"],
        title: "Python Tic Tac Toe",
        desc: "TicTacToe game program written in Python.",
        url: "https://github.com/marcoaobatista/Python-Tic-Tac-Toe",
      },
    ];
    return (
      <div id="projects">
        <div className="projects-header">
          <h2>
            <span className="italic-thin">PROJECTS </span>TO QUACK ABOUT
            <span className="accent">:</span>
          </h2>
        </div>
        <div className="projects-list-container">
          <div className="projects-list">
            {projects.map((proj, i) => {
              return (
                <a href={proj.url}>
                  <div className="project">
                    <div>
                      <div className="project-header">
                        <h3>{proj.title}</h3>
                        <div>
                          {proj.techStack.map((e, i) => {
                            if (proj.techStack.length === i + 1) {
                              return <span className="accent">{e}</span>;
                            }
                            return <span className="accent">{e + ", "}</span>;
                          })}
                        </div>
                      </div>
                      <p className="caption">{proj.desc}</p>
                    </div>
                    <span className="project-arrow">↗</span>
                  </div>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default Projects;
